import React from 'react'
import { M_Table } from 'src/M_Components'

const DangerousGoods = ({ roles }) => {
  return (
    <M_Table entityName={'dangerousGoods'} rolePermissions={roles} />
  )
}

export default DangerousGoods